export const ListaFiliais = [
    {
        "Codigo": "01",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0001-56",
        "Nome": "SÃO JORGE MATRIZ",
        "RazaoSocial": null,
        "Oid": 2258657,
        "Descricao": "01-SÃO JORGE MATRIZ",
        "UserMessage": null
    },
    {
        "Codigo": "05",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0005-80",
        "Nome": "CONSOLACAO",
        "RazaoSocial": null,
        "Oid": 1224953,
        "Descricao": "05-CONSOLACAO",
        "UserMessage": null
    },
    {
        "Codigo": "06",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0006-60",
        "Nome": "zCEAB",
        "RazaoSocial": null,
        "Oid": 2272939,
        "Descricao": "06-zCEAB",
        "UserMessage": null
    },
    {
        "Codigo": "07",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0007-41",
        "Nome": "T-10",
        "RazaoSocial": null,
        "Oid": 2272640,
        "Descricao": "07-T-10",
        "UserMessage": null
    },
    {
        "Codigo": "08",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0008-22",
        "Nome": "T-63",
        "RazaoSocial": null,
        "Oid": 2272540,
        "Descricao": "08-T-63",
        "UserMessage": null
    },
    {
        "Codigo": "09",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0009-03",
        "Nome": "zPIO XII",
        "RazaoSocial": null,
        "Oid": 2272661,
        "Descricao": "09-zPIO XII",
        "UserMessage": null
    },
    {
        "Codigo": "10",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0010-47",
        "Nome": "RIO VERDE",
        "RazaoSocial": null,
        "Oid": 2373093,
        "Descricao": "10-RIO VERDE",
        "UserMessage": null
    },
    {
        "Codigo": "11",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "03.842.333/0011-28",
        "Nome": "CD BR060",
        "RazaoSocial": null,
        "Oid": 94115485,
        "Descricao": "11-CD BR060",
        "UserMessage": null
    },
    {
        "Codigo": "12",
        "EnderecoComercial": null,
        "Endereco": null,
        "InscricaoEstadual": null,
        "Telefone": null,
        "Celular": null,
        "Identificador": "76.087.964/0001-80",
        "Nome": "FILIAL PARA NFCE",
        "RazaoSocial": null,
        "Oid": 405450986,
        "Descricao": "12-FILIAL PARA NFCE",
        "UserMessage": null
    }
]
